import { useState as p } from "react";
const a = () => {
  const [e, o] = p({
    title: "媒體庫"
  }), s = () => {
    o((t) => ({
      ...t,
      opacity: 1,
      pointerEvents: "auto"
    }));
  }, n = () => {
    o((t) => ({
      ...t,
      opacity: 0,
      pointerEvents: "none"
    }));
  };
  return e.onCancel = n, {
    show: s,
    close: n,
    modalProps: e,
    setModalProps: o
  };
};
export {
  a as useSimpleModal
};
